/*
 * @Author: zxf
 * @Date: 2022-04-01 16:56:15
 * @Description: 3D指南针插件
 */

/* global THREE, requestAnimationFrame */

require('@/lib/three/three');

const Event = require('./event');
const Status = require('./status');
const initApi = require('./api');
const Methods = require('./methods/index');
const initHook = require('./hook');
const platform = require('@/utils/platform');
const Compass3D = require('./compass-3d');
const MiddleWare = require('./middle-ware');

/** @type {Compass3DPlugin} */

let me = null;

/**
 * 3D指南针管理
 */
function Compass3DPlugin() {
  me = this;

  this.compass3d = null;

  // 方向旋转弧度
  this.radian = 0;

  this.isInstall = false;
  this.quaternion = null;

  this.currentMode = null;
  this.futureMode = null;
  // 显隐控制状态，默认为可见
  this.isVisible = true;
}

Compass3DPlugin.prototype.env = ENV;
Compass3DPlugin.prototype.bundle = BUNDLE;
Compass3DPlugin.prototype.version = VERSION;

/** @type {String} 应用名 */
Compass3DPlugin.prototype.name = 'Compass3D';

/** 支持平台 */
Compass3DPlugin.prototype.supportPlatform = [platform.PC, platform.MOBILE];

/** @type {Object} 注册插槽API */
Compass3DPlugin.prototype.registeredApi = Object.create(null);

/** @type {Object} 监听插槽API */
Compass3DPlugin.prototype.onApi = Object.create(null);

/**
 * 注册
 */
Compass3DPlugin.prototype.register = function () {
  const qspace = this.parent || window.qspace;
  this.middleWare = new MiddleWare(qspace);

  // this.registeredApi[this.middleWare.NEED_UPDATE] = true;
  // this.registeredApi[this.middleWare.NEED_MODE_CHANGE] = true;

  /** 监听模式改变 */
  // this.onApi[this.middleWare.NEED_MODE_CHANGE] = (data) => {
  //   if (!this.compass3d) return;
  //   switch (data.mode) {
  //     case 'transitioning': {
  //       // this.compass3d.hide();
  //       break;
  //     }
  //     case 'panorama': {
  //       if (this.isVisible) {
  //         this.compass3d.hide();
  //       }
  //       break;
  //     }
  //     case 'dollhouse': {
  //       if (this.isVisible) {
  //         this.compass3d.show();
  //       }
  //       break;
  //     }
  //     case 'floorplan': {
  //       if (this.isVisible) {
  //         this.compass3d.show();
  //       }
  //       break;
  //     }
  //   }
  // };

  /** 监听相机旋转和模型朝向 */
  // this.onApi[this.middleWare.NEED_UPDATE] = (data) => {
  //   if (
  //     this.middleWare.getCurrentMode() === 'dollhouse' ||
  //     this.middleWare.getCurrentMode() === 'floorplan' ||
  //     this.middleWare.getCurrentMode() === 'transitioning'
  //   ) {
  //     // 获取模型的四元数朝向
  //     const modelQuaternion = this.middleWare.getQuaternion();
  //     if (JSON.stringify(this.quaternion) !== JSON.stringify(modelQuaternion)) {
  //       this.quaternion = modelQuaternion;
  //       this.setDirection(modelQuaternion);
  //     }
  //   }
  // };
};

/**
 * 初始化
 * @param {string} id - 容器ID
 * @param {Object} config - 配置对象
 * @param {Object|Array} config.defaultQuaternion - 默认相机朝向四元数
 */
Compass3DPlugin.prototype.init = function (id, config = {}) {
  this.compass3d = new Compass3D(id, config);
};

Compass3DPlugin.prototype.install = function (cb = () => {}) {
  if (!this.status) {
    this.status = new Status(this);
    this.methods = new Methods(this);

    initHook(this);
    initApi(this);
  }

  this.isInstall = true;
  this.status.enable = true;

  cb();
};

Compass3DPlugin.prototype.uninstall = function () {
  this.isInstall = false;
  this.status.enable = false;
};

/**
 * 显示指北针
 */
Compass3DPlugin.prototype.show = function () {
  if (this.compass3d) {
    this.compass3d.show();
    this.isVisible = true;
  }
};

/**
 * 隐藏指北针
 */
Compass3DPlugin.prototype.hide = function () {
  if (this.compass3d && this.compass3d) {
    this.compass3d.hide();
    this.isVisible = false;
  }
};

/**
 * 设置指北针方向
 */
Compass3DPlugin.prototype.setDirection = function (quaternion) {
  if (this.compass3d) {
    this.compass3d.updatePose(quaternion);
  }
};

/**
 * 设置显隐状态
 * @param {boolean} visible - 是否可见
 */
Compass3DPlugin.prototype.setVisible = function (visible) {
  this.isVisible = !!visible;
  if (this.compass3d) {
    if (this.isVisible) {
      this.compass3d.show();
    } else {
      this.compass3d.hide();
    }
  }
};

/**
 * 获取当前显隐状态
 * @returns {boolean} 当前显隐状态
 */
Compass3DPlugin.prototype.getVisible = function () {
  return this.isVisible;
};

/**
 * 切换显隐状态
 */
Compass3DPlugin.prototype.toggleVisible = function () {
  this.setVisible(!this.isVisible);
};

/**
 * 设置旋转角度
 * @param {number} rotationAngle - 旋转角度（度数）
 */
Compass3DPlugin.prototype.setRotationAngle = function (rotationAngle) {
  if (this.compass3d) {
    this.compass3d.setRotationAngle(rotationAngle);
  }
};

/**
 * 重置指北针到初始状态
 * 在模型切换时调用，确保指北针恢复到最初始的状态
 * @param {number} rotationAngle - 指北针的旋转角度（可选）
 */
Compass3DPlugin.prototype.reset = function (rotationAngle) {
  if (this.compass3d && this.compass3d.container) {
    // 保存当前配置和容器
    const container = this.compass3d.container;
    const config = this.compass3d.options || {};

    // 如果提供了旋转角度，更新配置
    if (rotationAngle !== undefined && rotationAngle !== null) {
      config.rotationAngle = rotationAngle;
    }

    // 销毁当前的指北针实例
    this.compass3d.destroy();

    // 重新创建指北针实例，恢复到初始状态
    this.compass3d = new Compass3D(container, config);

    // 重置四元数状态
    this.quaternion = null;
  }
};

// - 自定义事件 -

function defineProperty() {
  Object.defineProperties(me, {
    event: {
      get: () => Event,
    },
    eventStaus: {
      // get: () => EventStatus,
    },
    _methods: {
      get: () => Methods,
    },
  });
}

module.exports = Compass3DPlugin;
